// pr-approve-reject-page.component.ts

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PurchaseRequestService } from '../purchase-request.service';

@Component({
  selector: 'app-pr-approve-reject-page',
  templateUrl: './pr-approve-reject-page.component.html',
  styleUrls: ['./pr-approve-reject-page.component.scss']
})
export class PrApproveRejectPageComponent implements OnInit {
  prData: any = {};
  isLoading: boolean = true;
  isReadOnly: boolean = false; // ✅ False rakhenge
  prior: string = 'Normal';
  budget: any = { remainingAmount: 0 };
  isselected: boolean = false;
  isSelected: boolean = false;
  remark: any;
  hoveredItem: any = null;
  
  prId: string = '';
  companyId: string = '';
  empId: string = '';
  prCategory: string = 'Item PR';
  
  pendingApprove: any = {
    approvalStatus: '',
    emp_id: '',
    empRemark: '',
    approvalDetails: []
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private purchaseRequestService: PurchaseRequestService
  ) {}

  ngOnInit(): void {
    console.log('🚀 Component Initialized');
    
    
    // ✅ Get all params from URL
    this.route.queryParams.subscribe(params => {
      console.log('📋 Query Params:', params);
      
      this.prId = params['prId'] || params['prid'] || '';
      this.companyId = params['companyId'] || params['cmId'] || params['company_id'] || '';
      this.empId = params['empId'] || params['employeeId'] || '';
      this.prCategory = params['prCategory'] || params['prCat'] || 'Item PR';
      
      console.log('📋 PR ID:', this.prId);
      console.log('📋 Company ID:', this.companyId);
      console.log('📋 Emp ID:', this.empId);
      
      if (this.prId && this.companyId) {
        this.getPRDetails();
      } else {
        this.toastr.error('Missing PR ID or Company ID in URL');
        this.isLoading = false;
      }
    });

    // ✅ If no empId from URL, try localStorage
    if (!this.empId) {
      try {
        const storedData = localStorage.getItem('user_details') ?? '{}';
        const userDetails = JSON.parse(storedData);
        if (userDetails && userDetails.employeeId) {
          this.empId = userDetails.employeeId;
        }
        if (userDetails && userDetails.companyId && !this.companyId) {
          this.companyId = userDetails.companyId;
        }
      } catch (e) {
        console.log('No user details in localStorage');
      }
    }
    
    this.pendingApprove.emp_id = this.empId;
  }

  getPRDetails() {
    if (!this.prId || !this.companyId) {
      this.toastr.error('PR ID or Company ID is missing');
      this.isLoading = false;
      return;
    }

    const requestData = {
      pr_id: this.prId,
      company_id: this.companyId,
      prCategory: this.prCategory
    };

    console.log('📤 Sending POST request:', requestData);

    this.purchaseRequestService.getPRById(requestData).subscribe(
      (res: any) => {
        console.log('✅ API Response:', res);
        
        if (res && res.body && res.body.data && res.body.data.length > 0) {
          this.prData = res.body.data[0];
          this.prior = res.body.priority || 'Normal';
          this.budget = res.body.budgetData || { remainingAmount: 0 };
          this.isLoading = false;
          
          console.log('✅ PR Data loaded:', this.prData);
          
          // ✅ Authorization check - but allow approve/reject
          this.checkAuthorization();
        } else {
          this.toastr.error(res.body?.message || 'PR not found');
          this.isLoading = false;
        }
      },
      (error) => {
        console.error('❌ API Error:', error);
        this.toastr.error(error.error?.message || 'Failed to load PR details');
        this.isLoading = false;
      }
    );
  }

  // ✅ Authorization check - Approve/Reject allow karega
  checkAuthorization() {
    // ✅ Always allow approve/reject - No view only mode
    this.isReadOnly = false;
    console.log('✅ Approve/Reject enabled');
    
    // ✅ Just show warning if not the current approver
    if (this.prData && this.prData.tbl_prWorkFlowApproves) {
      const currentApproval = this.prData.tbl_prWorkFlowApproves.find(
        (item: any) => {
          const empIdMatch = String(item.emp_id) === String(this.empId);
          const statusMatch = item.progressStatus === 'Open' || item.progressStatus === 'Pending';
          return empIdMatch && statusMatch;
        }
      );
      
      if (!currentApproval && this.empId) {
        this.toastr.warning('You are not the current approver. Still you can approve/reject.', '', {
          timeOut: 3000
        });
      } else if (!this.empId) {
        this.toastr.warning('Please enter Employee ID to approve/reject', '', {
          timeOut: 3000
        });
      } else {
        this.toastr.success('You can approve or reject this PR', '', { timeOut: 2000 });
      }
    }
  }

  // ==================== UI Helper Methods ====================
  open(e: any) {
    if (e === 'Pending' || e === 'Open') return 'schedule';
    if (e === 'Approved') return 'check';
    if (e === 'Reject' || e === 'Rejected') return 'cancel';
    if (e === 'Close') return 'lock';
    return 'schedule';
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Pending':
      case 'Open': return 'rgb(255, 210, 48)';
      case 'Approved': return 'rgb(0, 128, 55)';
      case 'Reject':
      case 'Rejected': return 'rgb(255, 0, 0)';
      case 'Close': return '#6c757d';
      default: return '';
    }
  }

  // ==================== Cost Calculation ====================
  totalCost(rate: any, approveQty: any, prQty: any, index: number) {
    if (this.prData.tbl_prItemMappings && this.prData.tbl_prItemMappings[index]) {
      const total = (Number(rate) || 0) * (Number(approveQty) || 0);
      this.prData.tbl_prItemMappings[index].total = total;
      this.prData.tbl_prItemMappings[index].rejectQuantity = (Number(prQty) || 0) - (Number(approveQty) || 0);
    }
  }

  totalCostBom(rate: any, approveQty: any, prQty: any, index: any) {
    if (this.prData.tbl_prBOMMappings && this.prData.tbl_prBOMMappings[index]) {
      const total = (Number(rate) || 0) * (Number(approveQty) || 0);
      this.prData.tbl_prBOMMappings[index].total = total;
      this.prData.tbl_prBOMMappings[index].rejectQuantity = (Number(prQty) || 0) - (Number(approveQty) || 0);
    }
  }

  // ==================== Checkbox Handling ====================
  onItemCheckboxChange(item: any, index: number, event: any): void {
    if (!item.approveQuantity || Number(item.approveQuantity) <= 0) {
      this.toastr.warning('First enter approve quantity', '', { timeOut: 2000 });
      item.isSelected = false;
      event.target.checked = false;
      return;
    }

    if (Number(item.approveQuantity) > Number(item.quantity)) {
      this.toastr.error('Approve Quantity cannot be greater than PR Quantity', '', { timeOut: 2000 });
      item.isSelected = false;
      event.target.checked = false;
      return;
    }

    this.toggleCheckbox(item, index);
  }

  toggleCheckbox(item: any, index: number): void {
    if (!this.pendingApprove.approvalDetails) {
      this.pendingApprove.approvalDetails = [];
    }

    const apprv = this.prData.tbl_prItemMappings[index].approveQuantity;
    const reject = this.prData.tbl_prItemMappings[index].rejectQuantity;

    const selectedIndex = this.pendingApprove.approvalDetails.findIndex(
      (selectedItem: any) => selectedItem.prItemMap_id === item.prItemMap_id
    );

    if (selectedIndex === -1) {
      this.pendingApprove.approvalDetails.push({
        prItemMap_id: item.prItemMap_id,
        item_id: item.item_id,
        itemName: item.itemName,
        uom_id: item.uom_id,
        uomName: item.uomName,
        quantity: item.quantity,
        finalQuantity: apprv,
        approveQuantity: apprv,
        rejectQuantity: reject || 0,
        mVP: item.mVP,
        total: item.total,
        bom_id: item.bom_id,
        frequency: item.frequency,
        prServiceMap_id: '',
        prType: 'Item',
      });
    } else {
      this.pendingApprove.approvalDetails.splice(selectedIndex, 1);
    }
  }

  toggleBomCheckbox(item: any, index: any) {
    if (!this.pendingApprove.approvalDetails) {
      this.pendingApprove.approvalDetails = [];
    }
    const apprv = this.prData.tbl_prBOMMappings[index].approveQuantity;
    const reject = this.prData.tbl_prBOMMappings[index].rejectQuantity;

    const selectedIndex = this.pendingApprove.approvalDetails.findIndex(
      (selectedItem: any) => selectedItem.prItemMap_id === item.prItemMap_id
    );

    if (selectedIndex === -1) {
      this.pendingApprove.approvalDetails.push({
        prItemMap_id: item.prItemMap_id,
        item_id: item.item_id,
        itemName: item.itemName,
        uom_id: item.uom_id,
        uomName: item.uomName,
        quantity: item.quantity,
        finalQuantity: apprv,
        approveQuantity: apprv,
        rejectQuantity: reject || 0,
        mVP: item.mVP,
        total: item.total,
        bom_id: item.bom_id,
        frequency: item.frequency,
        prServiceMap_id: '',
        prType: 'BOM',
      });
    } else {
      this.pendingApprove.approvalDetails.splice(selectedIndex, 1);
    }
  }

  toggleServiceCheckbox(item: any, index: any) {
    if (!this.pendingApprove.approvalDetails) {
      this.pendingApprove.approvalDetails = [];
    }

    if (item.isSelected === true) {
      const exists = this.pendingApprove.approvalDetails.some(
        (detail: any) => detail.prServiceMap_id === item.prServiceMap_id
      );
      
      if (!exists) {
        this.pendingApprove.approvalDetails.push({
          prItemMap_id: item.prServiceMap_id,
          item_id: item.service_id,
          itemName: item.serviceName,
          uom_id: item.uom_id,
          uomName: item.uomName,
          quantity: item.quantity,
          finalQuantity: item.quantity,
          approveQuantity: item.quantity,
          rejectQuantity: 0,
          mVP: item.mVP,
          total: item.total,
          frequency: item.Frequency,
          bom_id: item.bom_id,
          prServiceMap_id: item.prServiceMap_id,
          prType: 'Service',
        });
      }
    } else {
      item.isSelected = false;
      const indexToRemove = this.pendingApprove.approvalDetails.findIndex(
        (detail: any) => detail.prServiceMap_id === item.prServiceMap_id
      );
      if (indexToRemove !== -1) {
        this.pendingApprove.approvalDetails.splice(indexToRemove, 1);
      }
    }

    if (this.prData.tbl_prServiceMappings?.length > 0 &&
        this.pendingApprove.approvalDetails?.length === this.prData.tbl_prServiceMappings?.length) {
      this.isSelected = true;
    } else {
      this.isSelected = false;
    }
  }

  SelectServiceItem() {
    if (this.isSelected == true) {
      this.prData.tbl_prServiceMappings.forEach((item: any) => {
        item.isSelected = true;
        const exists = this.pendingApprove.approvalDetails.some(
          (detail: any) => detail.prServiceMap_id === item.prServiceMap_id
        );
        if (!exists) {
          this.pendingApprove.approvalDetails.push({
            prItemMap_id: item.prServiceMap_id,
            item_id: item.service_id,
            itemName: item.serviceName,
            uom_id: item.uom_id,
            uomName: item.uomName,
            quantity: item.quantity,
            finalQuantity: item.quantity,
            approveQuantity: item.quantity,
            rejectQuantity: 0,
            mVP: item.mVP,
            total: item.total,
            frequency: item.Frequency,
            bom_id: item.bom_id,
            prServiceMap_id: item.prServiceMap_id,
            prType: 'Service',
          });
        }
      });
    } else {
      this.pendingApprove.approvalDetails = [];
      this.prData.tbl_prServiceMappings.forEach((item: any) => {
        item.isSelected = false;
      });
    }
  }

  selectAllItem(): void {
    const invalidItem = this.prData?.tbl_prItemMappings?.find(
      (item: any) =>
        !item.approveQuantity ||
        Number(item.approveQuantity) <= 0 ||
        Number(item.approveQuantity) > Number(item.quantity)
    );

    if (invalidItem) {
      this.toastr.warning('First enter valid approve quantity for all items', '', { timeOut: 2000 });
      this.isselected = false;
      return;
    }

    this.isselected = !this.isselected;

    if (this.isselected) {
      this.pendingApprove.approvalDetails = [];
      this.prData.tbl_prItemMappings.forEach((item: any) => {
        item.isSelected = true;
        this.pendingApprove.approvalDetails.push({
          prItemMap_id: item.prItemMap_id,
          item_id: item.item_id,
          itemName: item.itemName,
          uom_id: item.uom_id,
          uomName: item.uomName,
          quantity: item.quantity,
          finalQuantity: item.approveQuantity,
          approveQuantity: item.approveQuantity,
          rejectQuantity: item.rejectQuantity || 0,
          mVP: item.mVP,
          total: item.total,
          bom_id: item.bom_id,
          frequency: item.frequency,
          prServiceMap_id: '',
          prType: 'Item',
        });
      });
    } else {
      this.pendingApprove.approvalDetails = [];
      this.prData.tbl_prItemMappings.forEach((item: any) => {
        item.isSelected = false;
      });
    }
  }

  // ==================== APPROVE ACTION ====================
  save() {
    console.log('📤 Approve button clicked');
    
    // ✅ Check if empId exists
    if (!this.empId) {
      // ✅ If no empId, ask user to enter
      const enteredEmpId = prompt('Please enter your Employee ID to approve:');
      if (enteredEmpId && enteredEmpId.trim() !== '') {
        this.empId = enteredEmpId.trim();
        this.pendingApprove.emp_id = this.empId;
      } else {
        this.toastr.error('Employee ID is required to approve');
        return;
      }
    }

    // ✅ Check if items selected
    if (!this.pendingApprove.approvalDetails || 
        this.pendingApprove.approvalDetails.length === 0) {
      this.toastr.error('Please select at least one item for approval', '', {
        timeOut: 2000,
      });
      return;
    }

    // ✅ Check if all selected items have approve quantity
    const invalidItems = this.pendingApprove.approvalDetails.filter(
      (item: any) => !item.approveQuantity || Number(item.approveQuantity) <= 0
    );

    if (invalidItems.length > 0) {
      this.toastr.error('Please enter valid approve quantity for selected items');
      return;
    }

    this.pendingApprove.approvalStatus = 'Approved';
    this.pendingApprove.emp_id = this.empId;

    console.log('📤 Sending approval payload:', this.pendingApprove);

    this.purchaseRequestService.approvePr(
      this.prData.pr_id, 
      this.companyId, 
      this.pendingApprove
    ).subscribe(
      (res: any) => {
        console.log('✅ Approval Response:', res);
        if (res && res.body) {
          this.toastr.success(res.body.message || 'PR approved successfully');
          setTimeout(() => {
            this.router.navigate(['/admin/purchase/pending-for-approve']);
          }, 2000);
        }
      },
      (err) => {
        console.error('❌ Approval Error:', err);
        this.toastr.error(err.error?.message || 'Failed to approve PR');
      }
    );
  }

  // ==================== REJECT ACTION ====================
  saveRejectPR() {
    console.log('📤 Reject button clicked');
    
    // ✅ Check if empId exists
    if (!this.empId) {
      const enteredEmpId = prompt('Please enter your Employee ID to reject:');
      if (enteredEmpId && enteredEmpId.trim() !== '') {
        this.empId = enteredEmpId.trim();
        this.pendingApprove.emp_id = this.empId;
      } else {
        this.toastr.error('Employee ID is required to reject');
        return;
      }
    }

    // ✅ Check if remark entered
    if (!this.pendingApprove.empRemark || 
        this.pendingApprove.empRemark.trim() === '') {
      this.toastr.warning('Remark is mandatory for rejection', '', {
        timeOut: 2000
      });
      return;
    }

    this.pendingApprove.approvalStatus = 'Rejected';
    this.pendingApprove.emp_id = this.empId;

    console.log('📤 Sending rejection payload:', this.pendingApprove);

    this.purchaseRequestService.approvePr(
      this.prData.pr_id, 
      this.companyId, 
      this.pendingApprove
    ).subscribe(
      (res: any) => {
        console.log('✅ Rejection Response:', res);
        if (res && res.body) {
          this.toastr.success(res.body.message || 'PR rejected successfully');
          setTimeout(() => {
            this.router.navigate(['/admin/purchase/pending-for-approve']);
          }, 2000);
        }
      },
      (err) => {
        console.error('❌ Rejection Error:', err);
        this.toastr.error(err.error?.message || 'Failed to reject PR');
      }
    );
  }

  // ==================== UI Helpers ====================
  onMouseEnter(item: any) {
    this.hoveredItem = item;
  }

  onMouseLeave() {
    this.hoveredItem = null;
  }

  showRemark(item: any) {
    this.remark = item.empRemark;
  }

  download() {
    window.print();
  }
}